import React from "react";
import {useForm} from "react-hook-form";
import AuthLogo from "../Components/AuthLogo";
import AuthContainer from "../Components/Auth/Container";
import Input from "../Components/Form/Input";
import Button from "../Components/Form/Button";
import ElementWrapper from "../Components/Form/ElementWrapper";
import Form from "../Components/Auth/Form";
import {log_in} from '../../util/auth'
import api from '../../util/api';
import {CardElement, Elements, useStripe, useElements} from '@stripe/react-stripe-js';
import {MultiSelect} from "react-multi-select-component";
import TabContentLoading from "../Components/Main/Sidebar/TabContentLoading";
import {
    AuthInner,
    AuthFormWrapper,
    AuthContent,
    AuthNav,
    AuthContentHeader,
    AuthContentParagraph,
    AuthLoginLink,
    MobileAuthLoginLink,
    RegistrationPanel,
    RegistrationPanelSubHeader,
    RegistrationPanelHeader,
    GoBack,
    Plan,
    SelectedPlan,
    PlanCheckbox,
    PlanHeader,
    PlanDescription,
    ChangePlan,
    PlanPrice,
    PlanPriceSuperscript,
    PlanPriceMonth,
    BillingInput,
    StripeInputWrapper,
    BillingInputSmall,
    RegistrationWrapper,
    BillingSelect,
    TimezoneSelect,
    TimezoneLabel,
    VideoWrapper,
    YourselfLabel,
    YourselfSelect,
    ReviewHeading,
    AccountInformation,
    ReviewTotal,
    ReviewContent,
    ReviewStrong,
    FormError
} from './RegistrationStyles';
import moment from 'moment-timezone';

const timezones = moment.tz.names();

const Login = () => {
    const {register, handleSubmit, errors} = useForm();
    const [panel, setPanel] = React.useState(1);
    const [selectedPlan, setSelectedPlan] = React.useState('free');
    const [firstName, setFirstName] = React.useState(null);
    const [lastName, setLastName] = React.useState(null);
    const [email, setEmail] = React.useState(null);
    const [password, setPassword] = React.useState(null);
    const [timezone, setTimezone] = React.useState(null);
    const [billingName, setBillingName] = React.useState(null);
    const [paymentMethodId, setPaymentMethodId] = React.useState(null);
    const [billingAddress, setBillingAddress] = React.useState(null);
    const [billingCity, setBillingCity] = React.useState(null);
    const [billingState, setBillingState] = React.useState(null);
    const [loadingOpen, setLoadingOpen] = React.useState(false);
    const [billingFormError, setBillingFormError] = React.useState(null);
    const [accountFormError, setAccountFormError] = React.useState(null);
    const [registrationFormError, setRegistrationFormError] = React.useState(null);
    const stripe = useStripe();
    const elements = useElements();
    const [selectedInstruments, setSelectedInstruments] = React.useState([]);
    const [howDidYouHear, setHowDidYouHear] = React.useState('');
    const [instrumentOptions, setInstrumentOptions] = React.useState([]);
    const [jobTitleOptions, setJobTitleOptions] = React.useState([]);
    const [selectedJob, setSelectedJob] = React.useState('Freelance Instructor');
    const instrument_options = [
        {label: "Guitar", value: "Guitar"},
        {label: "Piano", value: "Piano"},
        {label: "Voice", value: "Voice"},
        {label: "Violin", value: "Violin"},
        {label: "Bass Guitar", value: "Bass Guitar"},
        {label: "Drums", value: "Drums"},
        {label: "Saxophone", value: "Saxophone"},
        {label: "Flute", value: "Flute"},
        {label: "Cello", value: "Cello"},
        {label: "Clarinet", value: "Clarinet"},
    ];
    const hear_about_options = [
        {label: "Google", value: "Google"},
        {label: "Another Instructor", value: "Another Instructor"},
        {label: "Student", value: "Student"},
        {label: "Word of Mouth", value: "Word of Mouth"},
        {label: "Instagram", value: "Instagram"},
        {label: "Facebook", value: "Facebook"},
        {label: "Other", value: "Other"},
    ];

    React.useEffect(() => {
        async function fetchData() {
            // Mocking an axios return with what I think will be inside. Will likely need to be updated.
            api().get('/instruments').then((response) => {
                var instruments = [];
                response.data.data.forEach((item) => {
                    instruments.push({
                        label: item.name,
                        value: item.name
                    });
                });
                setInstrumentOptions(instruments);
            });
            api().get('/job-titles').then((response) => {
                var jobTitles = [];
                response.data.data.forEach((item) => {
                    jobTitles.push({
                        label: item.name,
                        value: item.name
                    });
                });
                setJobTitleOptions(jobTitles);
            });
        }

        fetchData();
    }, []);

    const onSubmit = (data) => {

        api().post('/check-email', {
            email: data.email
        }).then((response) => {
            if (!response.data.success) {
                setFirstName(data.first_name);
                setLastName(data.last_name);
                setEmail(data.email);
                setPassword(data.password);
                setTimezone(data.timezone);
                setPanel(panel + 1);
                setAccountFormError(null);
            } else {
                setAccountFormError('This email address has already been taken');
            }
        });
    };

    const handleCCSubmit = async (event) => {
        // Block native form submission.
        event.preventDefault();

        if (!stripe || !elements) {
            // Stripe.js has not loaded yet. Make sure to disable
            // form submission until Stripe.js has loaded.
            return;
        }

        // Get a reference to a mounted CardElement. Elements knows how
        // to find your CardElement because there can only ever be one of
        // each type of element.
        const cardElement = elements.getElement(CardElement);

        // Use your card Element with other Stripe.js APIs
        const {error, paymentMethod} = await stripe.createPaymentMethod({
            type: 'card',
            card: cardElement,
            billing_details: {
                address: {
                    city: billingCity,
                    line1: billingAddress,
                    state: billingState
                },
                name: billingName
            }
        });

        if (error) {
            setBillingFormError(error.message);
        } else {
            if (paymentMethod) {
                setPaymentMethodId(paymentMethod.id);
                setPanel(panel + 1);
            }
        }
    };

    return (
        <RegistrationWrapper>
            <AuthInner>
                <AuthNav><AuthLogo/><AuthLoginLink href="/login">Already a user? — Log In</AuthLoginLink></AuthNav>
                <AuthContent>
                    <AuthContentHeader>The future of music lessons is here!</AuthContentHeader>
                    <AuthContentParagraph>Your music assistant and virtual studio - all in one. Get into the rhythm of
                        optimized teaching with Muze.</AuthContentParagraph>
                    <AuthContentParagraph>Muze was built for music teachers, by music teachers so it has everything you
                        need:</AuthContentParagraph>
                    <ul>
                        <li>Quality sound</li>
                        <li>Elevated learning</li>
                        <li>Scheduling tools</li>
                        <li>Digital Library to record, report and track progress</li>
                    </ul>
                    <AuthContentParagraph>Unlock the power of Muze today by starting your 21 day free
                        trial.</AuthContentParagraph>
                    <VideoWrapper>
                        <iframe src="https://www.youtube.com/embed/Ufrl_r0CWxI" title="YouTube video player"
                                frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowfullscreen></iframe>
                    </VideoWrapper>
                </AuthContent>
                <AuthFormWrapper>
                <MobileAuthLoginLink href="/login">Already a user? — Log In</MobileAuthLoginLink>
                    <AuthContainer>
                        <RegistrationPanel active={panel == 1}>
                            <RegistrationPanelHeader>Create an Instructor Account</RegistrationPanelHeader>
                            <Form onSubmit={handleSubmit(onSubmit)}>
                                {accountFormError ? <FormError>{accountFormError}</FormError> : ''}
                                <ElementWrapper>
                                    <Input
                                        id="first_name"
                                        label="First Name"
                                        type="text"
                                        ref={register({
                                            required: {
                                                value: true,
                                                message: "First Name is Required",
                                            },
                                        })}
                                        errors={errors.first_name}
                                        autocomplete='given-name'
                                    />
                                </ElementWrapper>
                                <ElementWrapper>
                                    <Input
                                        id="last_name"
                                        label="Last Name"
                                        type="text"
                                        ref={register({
                                            required: {
                                                value: true,
                                                message: "Last Name is Required",
                                            },
                                        })}
                                        errors={errors.last_name}
                                        autocomplete='family-name'
                                    />
                                </ElementWrapper>
                                <ElementWrapper>
                                    <Input
                                        id="email"
                                        label="Email"
                                        type="email"
                                        ref={register({
                                            required: {
                                                value: true,
                                                message: "Email is Required",
                                            },
                                        })}
                                        errors={errors.email}
                                        autocomplete='email'
                                    />
                                </ElementWrapper>
                                <ElementWrapper>
                                    <Input
                                        id="password"
                                        label="Password"
                                        type="password"
                                        ref={register({
                                            required: {
                                                value: true,
                                                message: "Password is Required",
                                            },
                                        })}
                                        errors={errors.password}
                                        autocomplete='new-password'
                                    />
                                </ElementWrapper>
                                <ElementWrapper>
                                    <TimezoneLabel htmlFor="timezone">Timezone</TimezoneLabel>
                                    <TimezoneSelect
                                        id="timezone"
                                        name="timezone"
                                        defaultValue="America/New_York"
                                        ref={register({required: true})}>
                                        {timezones.map(timezone => (
                                            <option value={timezone}>{timezone}</option>
                                        ))}
                                    </TimezoneSelect>
                                </ElementWrapper>
                                <ElementWrapper>
                                    <Button width={'narrow'}>Next</Button>
                                </ElementWrapper>
                            </Form>
                        </RegistrationPanel>
                        <RegistrationPanel active={panel == 2}>
                            <RegistrationPanelHeader>Select Your Plan</RegistrationPanelHeader>
                            <RegistrationPanelSubHeader>You can cancel anytime.</RegistrationPanelSubHeader>

                            <Plan hidden={true} htmlFor="free">
                                <PlanCheckbox name="plan_type" id="free" type="radio"
                                              checked={selectedPlan == 'free'} onChange={() => {
                                    setSelectedPlan('free');
                                }}/>
                                <PlanHeader>Free Muze Beta</PlanHeader>
                                <PlanDescription>Try Muze Beta for 21 days</PlanDescription>
                                <PlanPrice>Free</PlanPrice>
                            </Plan>
                            <Plan hidden={false} htmlFor="yearly">
                                <PlanCheckbox name="plan_type" id="yearly" type="radio"
                                              checked={selectedPlan == 'yearly'} onChange={() => {
                                    setSelectedPlan('yearly');
                                }}/>
                                <PlanHeader>Yearly</PlanHeader>
                                <PlanDescription>Includes 21 day free trial</PlanDescription>
                                <PlanPrice><PlanPriceSuperscript>$</PlanPriceSuperscript>120<PlanPriceMonth>/yr</PlanPriceMonth></PlanPrice>
                            </Plan>
                            <Plan hidden={false} htmlFor="monthly">
                                <PlanCheckbox name="plan_type" id="monthly" type="radio"
                                              checked={selectedPlan == 'monthly'} onChange={() => {
                                    setSelectedPlan('monthly');
                                }}/>
                                <PlanHeader>Monthly</PlanHeader>
                                <PlanDescription>Includes 21 day free trial</PlanDescription>
                                <PlanPrice><PlanPriceSuperscript>$</PlanPriceSuperscript>12<PlanPriceMonth>/mo</PlanPriceMonth></PlanPrice>
                            </Plan>
                            <ElementWrapper>
                                <GoBack onClick={() => {
                                    setPanel(panel - 1)
                                }}>Go Back</GoBack>
                                <Button onClick={() => {
                                    setPanel(panel + 1);
                                }} width={'narrow'}>Next</Button>
                            </ElementWrapper>
                        </RegistrationPanel>
                        <RegistrationPanel active={panel == 3}>

                            <RegistrationPanelHeader>Billing Information</RegistrationPanelHeader>
                            <SelectedPlan>
                                <PlanCheckbox type="radio" defaultChecked={true}/>
                                <PlanHeader>{selectedPlan}</PlanHeader>
                                <ChangePlan onClick={() => {
                                    setPanel(panel - 1)
                                }}>Change Plan</ChangePlan>
                                <PlanPrice>{selectedPlan == 'yearly' ? '$120/yr' : (selectedPlan == 'monthly' ? '$12/mo' : 'Free')}</PlanPrice>
                            </SelectedPlan>

                            {selectedPlan !== 'free' ?
                                <>

                                    <form onSubmit={handleCCSubmit}>
                                        <h4>Billing Information</h4>
                                        {billingFormError ? <FormError>{billingFormError}</FormError> : ''}
                                        <BillingInput required onChange={(e) => {
                                            setBillingName(e.target.value);
                                        }} type="text" placeholder="Name on Card"/>
                                        <StripeInputWrapper>
                                            <CardElement
                                                options={{
                                                    style: {
                                                        base: {
                                                            fontSize: '16px',
                                                            border: '1px solid black',
                                                            color: '#424770',
                                                            '::placeholder': {
                                                                color: '#aab7c4',
                                                            },
                                                        },
                                                        invalid: {
                                                            color: '#9e2146',
                                                        },
                                                    },
                                                }}
                                            />
                                        </StripeInputWrapper>
                                        <BillingInput required onChange={(e) => {
                                            setBillingAddress(e.target.value);
                                        }} type="text" placeholder="Enter Street Address"/>
                                        <BillingInputSmall required onChange={(e) => {
                                            setBillingCity(e.target.value);
                                        }} type="text" placeholder="City"/>
                                        <BillingSelect required onChange={(e) => {
                                            setBillingState(e.target.value);
                                        }}>
                                            <option>State</option>
                                            <option value="AL">Alabama</option>
                                            <option value="AK">Alaska</option>
                                            <option value="AZ">Arizona</option>
                                            <option value="AR">Arkansas</option>
                                            <option value="CA">California</option>
                                            <option value="CO">Colorado</option>
                                            <option value="CT">Connecticut</option>
                                            <option value="DE">Delaware</option>
                                            <option value="DC">District Of Columbia</option>
                                            <option value="FL">Florida</option>
                                            <option value="GA">Georgia</option>
                                            <option value="HI">Hawaii</option>
                                            <option value="ID">Idaho</option>
                                            <option value="IL">Illinois</option>
                                            <option value="IN">Indiana</option>
                                            <option value="IA">Iowa</option>
                                            <option value="KS">Kansas</option>
                                            <option value="KY">Kentucky</option>
                                            <option value="LA">Louisiana</option>
                                            <option value="ME">Maine</option>
                                            <option value="MD">Maryland</option>
                                            <option value="MA">Massachusetts</option>
                                            <option value="MI">Michigan</option>
                                            <option value="MN">Minnesota</option>
                                            <option value="MS">Mississippi</option>
                                            <option value="MO">Missouri</option>
                                            <option value="MT">Montana</option>
                                            <option value="NE">Nebraska</option>
                                            <option value="NV">Nevada</option>
                                            <option value="NH">New Hampshire</option>
                                            <option value="NJ">New Jersey</option>
                                            <option value="NM">New Mexico</option>
                                            <option value="NY">New York</option>
                                            <option value="NC">North Carolina</option>
                                            <option value="ND">North Dakota</option>
                                            <option value="OH">Ohio</option>
                                            <option value="OK">Oklahoma</option>
                                            <option value="OR">Oregon</option>
                                            <option value="PA">Pennsylvania</option>
                                            <option value="RI">Rhode Island</option>
                                            <option value="SC">South Carolina</option>
                                            <option value="SD">South Dakota</option>
                                            <option value="TN">Tennessee</option>
                                            <option value="TX">Texas</option>
                                            <option value="UT">Utah</option>
                                            <option value="VT">Vermont</option>
                                            <option value="VA">Virginia</option>
                                            <option value="WA">Washington</option>
                                            <option value="WV">West Virginia</option>
                                            <option value="WI">Wisconsin</option>
                                            <option value="WY">Wyoming</option>
                                        </BillingSelect>
                                        <ElementWrapper>
                                            <GoBack onClick={() => {
                                                setPanel(panel - 1)
                                            }}>Go Back</GoBack>
                                            <Button width={'narrow'}>Next</Button>
                                        </ElementWrapper>
                                    </form>
                                </> : <>
                                    <ElementWrapper>
                                        <GoBack onClick={() => {
                                            setPanel(panel - 1)
                                        }}>Go Back</GoBack>
                                        <Button onClick={() => {
                                            setPanel(panel + 1)
                                        }} width={'narrow'}>Next</Button>
                                    </ElementWrapper>
                                </>}

                        </RegistrationPanel>
                        <RegistrationPanel active={panel === 4}>
                            <RegistrationPanelHeader>Tell Us About Yourself</RegistrationPanelHeader>
                            <YourselfLabel>I am a...</YourselfLabel>
                            <YourselfSelect required onChange={(e) => {
                                setSelectedJob(e.target.value);
                            }}>
                                {
                                    jobTitleOptions.map((item, index) => {
                                        return <option value={item.value}>{item.label}</option>;
                                    })
                                }
                            </YourselfSelect>
                            <YourselfLabel>Your Instruments</YourselfLabel>
                            <MultiSelect
                                required
                                options={instrument_options}
                                value={selectedInstruments}
                                onChange={setSelectedInstruments}
                                labelledBy={"Select"}
                            />
                            <br/>
                            <YourselfLabel>How Did You Hear About Us?</YourselfLabel>

                            <Input type="text"
                                   value={howDidYouHear}
                                   onChange={(e) => {
                                       setHowDidYouHear(e.target.value)
                                   }}
                            /><br/>
                            <ElementWrapper>
                                <GoBack onClick={() => {
                                    setPanel(panel - 1)
                                }}>Go Back</GoBack>
                                <Button onClick={() => {
                                    setPanel(panel + 1);
                                }} width={'narrow'}>Next</Button>
                            </ElementWrapper>
                        </RegistrationPanel>
                        <RegistrationPanel active={panel == 5}>
                            <TabContentLoading registration={true} open={loadingOpen}><i className="fa fa-spinner"></i></TabContentLoading>
                            <RegistrationPanelHeader>Review Account Information</RegistrationPanelHeader>
                            {registrationFormError ? <FormError>{registrationFormError}</FormError> : ''}
                            <ReviewHeading>Account Information</ReviewHeading>
                            <AccountInformation>
                                <ReviewContent>{firstName} {lastName}</ReviewContent>
                                <ReviewContent>{email}</ReviewContent>
                                <ReviewContent>{selectedJob}</ReviewContent>
                                <ReviewContent>{howDidYouHear}</ReviewContent>
                                <ReviewContent>
                                    {
                                        selectedInstruments.map((item, index) =>
                                            (selectedInstruments.length - 1) == index ? item.value + " " : item.value + ", "
                                        )
                                    }
                                </ReviewContent>
                            </AccountInformation>
                            <ReviewHeading>Your Plan</ReviewHeading>


                            <SelectedPlan>
                                <PlanCheckbox type="radio" defaultChecked={true}/>
                                <PlanHeader>{selectedPlan}</PlanHeader>
                                <ChangePlan onClick={() => {
                                    setPanel(panel - 1)
                                }}>Change Plan</ChangePlan>
                                <PlanPrice>{selectedPlan == 'yearly' ? '$120/yr' : (selectedPlan == 'monthly' ? '$12/mo' : 'Free')}</PlanPrice>
                            </SelectedPlan>
                            <hr/>
                            <br/>
                            <ReviewTotal>Today's Total: <ReviewStrong>$0</ReviewStrong></ReviewTotal>
                            <ElementWrapper>
                                <GoBack onClick={() => {
                                    setPanel(panel - 1)
                                }}>Go Back</GoBack>
                                <Button onClick={() => {
                                    setLoadingOpen(true);
                                    setRegistrationFormError(null);
                                    axios.post('/register-instructor', {
                                        paymentMethodId: paymentMethodId,
                                        firstName: firstName,
                                        lastName: lastName,
                                        email: email,
                                        password: password,
                                        selectedJob: selectedJob,
                                        selectedInstruments: selectedInstruments,
                                        selectedPlan: selectedPlan,
                                        howDidYouHear: howDidYouHear,
                                        timezone: timezone
                                    }).then((response) => {

                                        setLoadingOpen(false);
                                        if (response.data.success) {
                                            window.dataLayer = window.dataLayer || [];
                                            window.dataLayer.push({
                                                'event': 'registrationComplete',
                                                'gtm.elementId': 'Registration Complete (Instructor)'
                                            });
                                            setPanel(panel + 1);
                                        } else {
                                            setPanel(5);
                                            setRegistrationFormError(response.data.error);
                                        }

                                    });
                                }} width={'narrow'}>Start Free Trial</Button>
                            </ElementWrapper>
                        </RegistrationPanel>
                        <RegistrationPanel id="payment-confirmation-panel" active={panel == 6}>
                            <RegistrationPanelHeader>Payment Confirmation</RegistrationPanelHeader>
                            <ReviewHeading>Payment Confirmed</ReviewHeading>
                            <AccountInformation>
                                <ReviewContent>Thank you. Your registration has been successful. A confirmation will be
                                    sent to your email.</ReviewContent>
                                <br/>
                                <ReviewContent>Email: <ReviewStrong>{email}</ReviewStrong></ReviewContent>
                                <ReviewContent>{selectedPlan == 'yearly' ? 'Yearly' : 'Monthly'} Plan:
                                    <ReviewStrong>{selectedPlan == 'yearly' ? '$120/yr' : (selectedPlan == 'monthly' ? '$12/mo' : 'Free')}</ReviewStrong></ReviewContent>
                                <br/>
                                <ReviewContent>Don't forget, you can cancel anytime.</ReviewContent>
                                <br/>
                            </AccountInformation>
                            <hr/>
                            <RegistrationPanelHeader>Get Started with Muze!</RegistrationPanelHeader>
                            <ElementWrapper>
                                <Button onClick={() => {
                                    api(true).post('/fortify/login', {
                                        email: email,
                                        password: password
                                    }).then(() => {
                                        log_in();

                                        window.location.href = '/';
                                    }).catch((error) => {
                                        if (error.response) {
                                        }
                                    });
                                }} width={'narrow'}>Continue to Muze</Button>
                            </ElementWrapper>
                        </RegistrationPanel>
                    </AuthContainer>

                </AuthFormWrapper>
            </AuthInner>
            <a href="https://www.iubenda.com/terms-and-conditions/78095235"
               className="iubenda-white no-brand iubenda-embed terms-conditions" title="Terms and Conditions ">Terms and
                Conditions</a>
        </RegistrationWrapper>
    );
};

export default Login;
